// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const WormSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'worm-idle',
    metadata: {
      frames: {
        'worm-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-idle-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-idle-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-idle-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-idle-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/worm/idle.png',
        size: {
          w: 320,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'worm-idle': [
          'worm-idle-0',
          'worm-idle-1',
          'worm-idle-2',
          'worm-idle-3',
          'worm-idle-4',
        ],
      },
    },
  },
  {
    name: 'worm-walk',
    metadata: {
      frames: {
        'worm-walk-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-walk-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-walk-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-walk-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-walk-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/worm/walk.png',
        size: {
          w: 320,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'worm-walk': [
          'worm-walk-0',
          'worm-walk-1',
          'worm-walk-2',
          'worm-walk-3',
          'worm-walk-4',
        ],
      },
    },
  },
  {
    name: 'worm-attack1',
    metadata: {
      frames: {
        'worm-attack1-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-attack1-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-attack1-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-attack1-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-attack1-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-attack1-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/worm/attack1.png',
        size: {
          w: 384,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'worm-attack1': [
          'worm-attack1-0',
          'worm-attack1-1',
          'worm-attack1-2',
          'worm-attack1-3',
          'worm-attack1-4',
          'worm-attack1-5',
        ],
      },
    },
  },
  {
    name: 'worm-hide',
    metadata: {
      frames: {
        'worm-hide-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-6': {
          frame: {
            x: 384,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-7': {
          frame: {
            x: 448,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-8': {
          frame: {
            x: 512,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-9': {
          frame: {
            x: 576,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-10': {
          frame: {
            x: 640,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-11': {
          frame: {
            x: 704,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-12': {
          frame: {
            x: 768,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-13': {
          frame: {
            x: 832,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-14': {
          frame: {
            x: 896,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-15': {
          frame: {
            x: 960,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-16': {
          frame: {
            x: 1024,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-17': {
          frame: {
            x: 1088,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-18': {
          frame: {
            x: 1152,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-19': {
          frame: {
            x: 1216,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-20': {
          frame: {
            x: 1280,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hide-21': {
          frame: {
            x: 1344,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/worm/hide.png',
        size: {
          w: 1408,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'worm-hide': [
          'worm-hide-0',
          'worm-hide-1',
          'worm-hide-2',
          'worm-hide-3',
          'worm-hide-4',
          'worm-hide-5',
          'worm-hide-6',
          'worm-hide-7',
          'worm-hide-8',
          'worm-hide-9',
          'worm-hide-10',
          'worm-hide-11',
          'worm-hide-12',
          'worm-hide-13',
          'worm-hide-14',
          'worm-hide-15',
          'worm-hide-16',
          'worm-hide-17',
          'worm-hide-18',
          'worm-hide-19',
          'worm-hide-20',
          'worm-hide-21',
        ],
      },
    },
  },
  {
    name: 'worm-appear',
    metadata: {
      frames: {
        'worm-appear-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-appear-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-appear-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-appear-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-appear-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-appear-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-appear-6': {
          frame: {
            x: 384,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-appear-7': {
          frame: {
            x: 448,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-appear-8': {
          frame: {
            x: 512,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-appear-9': {
          frame: {
            x: 576,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-appear-10': {
          frame: {
            x: 640,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-appear-11': {
          frame: {
            x: 704,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-appear-12': {
          frame: {
            x: 768,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/worm/appear.png',
        size: {
          w: 832,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'worm-appear': [
          'worm-appear-0',
          'worm-appear-1',
          'worm-appear-2',
          'worm-appear-3',
          'worm-appear-4',
          'worm-appear-5',
          'worm-appear-6',
          'worm-appear-7',
          'worm-appear-8',
          'worm-appear-9',
          'worm-appear-10',
          'worm-appear-11',
          'worm-appear-12',
        ],
      },
    },
  },
  {
    name: 'worm-hit',
    metadata: {
      frames: {
        'worm-hit-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hit-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hit-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-hit-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/worm/hit.png',
        size: {
          w: 256,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'worm-hit': ['worm-hit-0', 'worm-hit-1', 'worm-hit-2', 'worm-hit-3'],
      },
    },
  },
  {
    name: 'worm-dead',
    metadata: {
      frames: {
        'worm-dead-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-dead-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-dead-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-dead-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-dead-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'worm-dead-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/worm/dead.png',
        size: {
          w: 384,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'worm-dead': [
          'worm-dead-0',
          'worm-dead-1',
          'worm-dead-2',
          'worm-dead-3',
          'worm-dead-4',
          'worm-dead-5',
        ],
      },
    },
  },
];
